import { AppConfigSet, loadAppSetUp } from '@gjensidige/se-content-helpers';
import {
  fetchGenericIllustrations,
  IllustrationType
} from '@gjensidige/se-content-helpers';
import { apiFetcher } from '@gjensidige/service-async';

export class AppHelper {
  static AppTexts: any = {};
  static AppIllustrations: any = [];
  static CmsData: any = {};

  static getText = (key: string): string => {
    return AppHelper.AppTexts ? AppHelper.AppTexts[key] : '';
  };

  static fetchInitialData = async () => {
    const configSet = [AppConfigSet.GENERIC_ILLUSTRATION];
    const staticData = await loadAppSetUp('calculation-widget-se', configSet);
    AppHelper.AppTexts = staticData[0];
    AppHelper.AppIllustrations = JSON.stringify(staticData[1]);
  };

  static fetchImageUrl = async (
    fileName: string,
    fileType: IllustrationType
  ) => {
    return fetchGenericIllustrations(
      fileName,
      fileType,
      JSON.parse(AppHelper.AppIllustrations)
    );
  };

  static parseStringBooleans = (obj: any): any => {
    if (obj === null || obj === undefined) {
      return obj;
    }

    if (typeof obj === 'string') {
      // Check if string represents a boolean
      if (obj.toLowerCase() === 'true') return true;
      if (obj.toLowerCase() === 'false') return false;
      return obj; // Return original string if not a boolean
    }

    if (Array.isArray(obj)) {
      return obj.map(item => AppHelper.parseStringBooleans(item));
    }

    if (typeof obj === 'object') {
      const parsed: any = {};
      for (const [key, value] of Object.entries(obj)) {
        parsed[key] = AppHelper.parseStringBooleans(value);
      }
      return parsed;
    }

    return obj; // Return primitive values as-is
  };

  static getEnonicContent = async (dataUrl: string, dataObject: any) => {
    //const response: any = await apiFetcher.postJson(dataUrl)
    let enonicData = {
      imageFileName: '',
      smallScreenImageFileName: '',
      hideImageOnSmallScreens: false,
      headerText: '',
      imageAltText: '',
      regNumberLabel: '',
      regNumberPlaceHolder: '',
      cprNumberLabel: '',
      cprNumberPlaceHolder: '',
      cprNumberHelpText: '',
      calculateBtnLabel: '',
      footerMessage: ''
    };
    if (dataObject) {
      try {
        const parsedData = JSON.parse(dataObject);
        enonicData = AppHelper.parseStringBooleans(parsedData);
      } catch {
        return enonicData;
      }
    } else {
      const response: any = await apiFetcher.postJson(dataUrl);
      if (response.isOk()) {
        if (response.value) {
          enonicData = AppHelper.parseStringBooleans(response.value);
        }
      }
    }
    return enonicData;
  };
}
